import { map } from 'rxjs/operators';
import { DEFAULT_ERROR_MSG } from 'HypotheticalsApp/apps/hypotheticals-app/constants';
import { BaseSavedItemService } from 'NewAngular/features/components/saved-items/services/common-services/base-saved-item.service';
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { convertNestedStringToBoolean } from 'NewAngular/utils/state-utils';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class SavedHypotheticalService extends BaseSavedItemService {
    constructor(ajaxService, urlsService) {
        super();
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getFolderableItems(params) {
        return this.ajaxService.getDataObserveBody(this.urlsService.HYPOTHETICALS.HYPOTHETICALS_COLLECTION, params);
    }
    createItem(postParams, itemName) {
        const params = { state: postParams, name: itemName };
        const postUrl = this.urlsService.getUrl(this.urlsService.HYPOTHETICALS.SAVED_HYPOTHETICALS);
        return this.ajaxService.postJsonDataObserveBody(postUrl, params).pipe(map((response) => {
            convertNestedStringToBoolean(response);
            return response;
        }));
    }
    deleteItem(hypotheticalId) {
        const deleteUrl = this.urlsService.getUrl(this.urlsService.HYPOTHETICALS.HYPOTHETICALS_ITEM, {
            hypotheticalId,
        });
        return this.ajaxService.deleteDataObserveBody(deleteUrl);
    }
    getErrorMessage(error) {
        let errorMessage;
        switch (error.status) {
            case 404:
                errorMessage = 'Scenario not found, please try again.';
                break;
            case 403:
                errorMessage = error.error?.error_message ?? DEFAULT_ERROR_MSG;
                break;
            case 409:
                errorMessage = 'Cannot save with duplicate name, please try again.';
                break;
            default:
                errorMessage = DEFAULT_ERROR_MSG;
                break;
        }
        return errorMessage;
    }
    getItem(hypotheticalId) {
        return this.ajaxService
            .getDataObserveBody(this.urlsService.getUrl(this.urlsService.HYPOTHETICALS.HYPOTHETICALS_ITEM, { hypotheticalId }))
            .pipe(map((response) => {
            convertNestedStringToBoolean(response);
            return response;
        }));
    }
    getItems() {
        return this.ajaxService
            .getDataObserveBody(this.urlsService.getUrl(this.urlsService.HYPOTHETICALS.SAVED_HYPOTHETICALS))
            .pipe(map((response) => {
            convertNestedStringToBoolean(response);
            return response;
        }));
    }
    updateItem(hypotheticalId, putParams) {
        const putUrl = this.urlsService.getUrl(this.urlsService.HYPOTHETICALS.HYPOTHETICALS_ITEM, {
            hypotheticalId,
        });
        return this.ajaxService.putJsonDataObserveBody(putUrl, putParams);
    }
}
SavedHypotheticalService.ɵfac = function SavedHypotheticalService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SavedHypotheticalService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
SavedHypotheticalService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SavedHypotheticalService, factory: SavedHypotheticalService.ɵfac, providedIn: 'root' });
